module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/207/assets/images/6fd8eaf0006500c101efc8fb1743b0e2.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_groups_minimise.svg
// module id = nEbz
// module chunks = 1